<template>
  <v-container class="pt-0" fluid>
    <v-row align="center">
      <v-col cols="12">
        <tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getBulldozerrs()"
        />
      </v-col>
    </v-row>
    <dialog-alerta
      :dialog.sync="dialog"
    />
  </v-container>
</template>
<script>

import pusherMixins from '@/mixins/pusherMixins';
import BulldozerrService from "@/services/BulldozerrService";

export default {
  mixins: [pusherMixins],

  components: {
    Tabela:       () => import("@/components/bulldozerr/Tabela.vue"),
    DialogAlerta: () => import("@/components/bulldozerr/DialogAlerta.vue")
  },

  mounted() {
    this.getBulldozerrs();
  },

  data: () => ({
    items: [],
    loading: false,
    dialog: true
  }),

  methods: {
    getBulldozerrs() {
      this.loading = true;

      BulldozerrService.getBulldozerrs()
      .then(response => this.items = response.data.bulldozerr)
      .catch(err => {
        console.error(err);
        this.$toast.error('Não foi possivel recuperar os dados de cálculo bulldozerr', { position: 'topRight' })
      })
      .finally(() => this.loading = false)
    }
  }
}
</script>
